import { AttributesSelector, Checkbox, Field } from '@workwhile/ui'
import React, { useMemo } from 'react'
import { useNotificationTasksContextValue } from '../../../context/NotificationTasksProvider'
import { selectableColumns } from './columns'

export const ColumnsFilter = () => {
  const {
    state: { selectedColumnsFilters },
    actions: { setSelectedColumnsFilters },
  } = useNotificationTasksContextValue()

  const selectedAttributes = useMemo(() => {
    const selectedColumnsSet = new Set(selectedColumnsFilters)
    return selectableColumns
      .map((column) =>
        selectedColumnsSet.has(column.id) ? column.label : undefined
      )
      .filter((item): item is NonNullable<typeof item> => Boolean(item))
  }, [selectedColumnsFilters])

  const selectableColumnsCheckboxes = useMemo(() => {
    return selectableColumns.map((column) => {
      const isSelected = selectedColumnsFilters.includes(column.id)
      return (
        <Field key={column.id}>
          <Checkbox
            value={isSelected}
            onChange={() => {
              setSelectedColumnsFilters((prev) => {
                if (prev.includes(column.id)) {
                  return prev.filter((c) => c !== column.id)
                }
                return [...prev, column.id]
              })
            }}
          >
            <span>{column.label}</span>
          </Checkbox>
        </Field>
      )
    })
  }, [selectedColumnsFilters, setSelectedColumnsFilters])

  return (
    <AttributesSelector
      label="Columns"
      rootGroupTitle="Toggle Columns"
      selectedAttributes={selectedAttributes}
      onClearAll={() => {
        setSelectedColumnsFilters([])
      }}
      selectedAttributeLimit={0}
      groups={[
        <AttributesSelector.Group
          key="notification-task-columns"
          title="Columns"
          numberOfSelectedAttributes={selectedAttributes.length}
        >
          {selectableColumnsCheckboxes}
        </AttributesSelector.Group>,
      ]}
    />
  )
}
